import { ReactElement } from "react";
import {
	AlertBar,
	Form,
	FormItem,
	CopyControl,
	Dialog
} from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import styles from "./RevealApiKeyDialog.module.less";


export type RevealApiKeyDialogProps = {
	apiKey: string;
	onClose(): void;
};

export const RevealApiKeyDialog = (props: RevealApiKeyDialogProps): ReactElement => {
	const {
		apiKey,
		onClose
	} = props;
	return (
		<Dialog trackingId="reveal-api-key-dialog">
			<Dialog.Header title={localize("_ApiKeyGenerated")} onClose={onClose} />
			<Dialog.Body>
				<Form onSubmit="NONE">
					<div className={styles.alert}>
						<AlertBar
							kind="warning"
							isDismissable={false}
							isInline
						>
							{localize("_RevealApiKeyWarningMessage")}
						</AlertBar>
					</div>
					<FormItem label={localize("_ApiKey")}>
						<CopyControl
							value={apiKey}
							trackingId="api-key"
							buttonKind="primary"
						/>
					</FormItem>
				</Form>
			</Dialog.Body>

			<Dialog.Footer />
		</Dialog>
	);
};

RevealApiKeyDialog.displayName = "RevealApiKeyDialog";